import earcut from 'earcut';
import mapboxgl from 'mapbox-gl';
import * as twgl from 'twgl.js';

// These are the coordinates for two triangles that make up a unit square (with its lower left vertex at the origin)
const UNIT_QUAD = [0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1];

/**
 * Returns a twgl.BufferInfo object for the main program
 */
export const getBufferInfo = (
  gl, // WebGLRenderingContext
) =>
  twgl.createBufferInfoFromArrays(gl, {
    aPos: { numComponents: 2, data: UNIT_QUAD },
  });

/**
 * Returns a twgl.BufferInfo object for the mask program
 */
export const getMaskBufferInfo = (
  gl, // WebGLRenderingContext
  maskPolygons, // Array of geojson polygon features
) => {
  const positions = [];
  const triangles = [];
  let triangleStartIndex = 0;

  maskPolygons.forEach((data) => {
    if (!data.geometry || data.geometry.type !== 'Polygon') {
      throw new Error('Clipping mask must be a polygon feature.');
    }

    // Convert geographic coordinates to Mercator
    const { coordinates } = data.geometry;
    const converted = coordinates.map((coordArr) =>
      coordArr.map((coord) => {
        const mercator = mapboxgl.MercatorCoordinate.fromLngLat(coord);
        return [mercator.x, mercator.y];
      }),
    );

    // Flatten the polygon into triangles
    const flatten = earcut.flatten(converted);
    const { vertices, holes, dimensions } = flatten;
    const triangle = earcut(vertices, holes, dimensions);
    const triangleNew = triangle.map((item) => item + triangleStartIndex);

    triangleStartIndex += vertices.length / 2;
    positions.push(...vertices);
    triangles.push(...triangleNew);
  });

  return twgl.createBufferInfoFromArrays(gl, {
    aPos: { numComponents: 2, data: positions },
    indices: new Uint32Array(triangles),
  });
};
